import { render, staticRenderFns } from "./public-marquee.vue?vue&type=template&id=582e9ffa&scoped=true"
import script from "./public-marquee.vue?vue&type=script&lang=js"
export * from "./public-marquee.vue?vue&type=script&lang=js"
import style0 from "./public-marquee.vue?vue&type=style&index=0&id=582e9ffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e9ffa",
  null
  
)

export default component.exports